export const USER_GUIDE = "https://docs.google.com/document/d/1rxg1mce5k3gD6pQ95b1rVunQQ4nkX9ORnq3ewNgJJwk/edit";
export const USER_GUIDE_ENG = "https://docs.google.com/document/d/1rxg1mce5k3gD6pQ95b1rVunQQ4nkX9ORnq3ewNgJJwk/edit";
export const USER_GUIDE_BETA_ENG =
  "https://docs.google.com/document/d/e/2PACX-1vSsND7Vq7mKLgyRa1zzZKfZ4D1yDqJTwYgG5-wdwXXK3qYeJ3xErzKwcOQNYuBIrZSvA9o22ExLBFpq/pub";
export const USER_GUIDE_BETA_EDITOR =
  "https://docs.google.com/document/d/e/2PACX-1vSXKDW408w73_2zBYaqUU2WIM6iS9U992LEy5Rkn-Ie_Mvb_jjqmv9Gryi1LwOaFWkZHVRGF3hMNtzE/pub";
export const PRIVACY_POLICY =
  "https://docs.google.com/document/d/e/2PACX-1vTMi5_ZSa-pKOb1qJOO2gDd5DXmlqD5GubpoVig0nbrdxSmYjn4Jx_JyKhkvr5CnTM1jjS0l3AQ5x94/pub";
